import React, {FC} from 'react'
import CommerciumLoaderHost from 'src/utils/CommerciumLoaderHost'

type Props = {
  totalOrders: number
  percentChange: number | null
  loading?: boolean
}

const DashboardTotalOrdersCard: FC<Props> = ({totalOrders, percentChange, loading = false}) => {
  const hasTrend = percentChange !== null && Number.isFinite(percentChange)
  const isPositive = hasTrend && percentChange >= 0

  return (
    <div className='dashboard-panel-card dashboard-highlight-card dashboard-total-orders-card mb-3'>
      <div className='dashboard-panel-body'>
        <small className='dashboard-total-orders-label'>Total Orders (30 Days)</small>
        {loading ? (
          <CommerciumLoaderHost variant='section' layout='centered' compact className='py-2' />
        ) : (
          <>
            <h2 className='dashboard-total-orders-value'>{totalOrders.toLocaleString()}</h2>
            {hasTrend ? (
              <div className='dashboard-total-orders-trend'>
                {isPositive ? '↑' : '↓'} {Math.abs(percentChange).toFixed(1)}%{' '}
                {isPositive ? 'increase' : 'decrease'} from last month
              </div>
            ) : (
              <div className='dashboard-total-orders-trend opacity-75'>Last 30 days summary</div>
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default DashboardTotalOrdersCard
